import React from 'react';
import { useContacts } from '../../contexts/ContactContext';
import SafeIcon from '../../common/SafeIcon';
import { FiFilter, FiSearch } from 'react-icons/fi';


const ContactFilters = () => {
  const { 
    searchTerm, 
    setSearchTerm, 
    filterStatus, 
    setFilterStatus,
    getContactStats 
  } = useContacts();

  const stats = getContactStats();

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center justify-between">
        {/* Search */}
        <div className="relative flex-1 max-w-md">
          <SafeIcon 
            icon={FiSearch} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" 
          />
          <input
            type="text"
            placeholder="Search contacts..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Filters */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiFilter} className="text-gray-400" />
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Contacts</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          {/* Quick Stats */}
          <div className="flex items-center gap-4 text-sm text-gray-600">
            <span>Total: <span className="font-medium text-gray-900">{stats.total}</span></span>
            <span>Active: <span className="font-medium text-green-600">{stats.active}</span></span>
            <span>Recent: <span className="font-medium text-blue-600">{stats.recent}</span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactFilters;